import React from "react";
import { Grid } from "semantic-ui-react";
import cv from "../../../assets/icons/cv.svg";
import coverLetterIcon from "../../../assets/icons/cover-letter.svg";
import linkedinIconL from "../../../assets/icons/linkedinIconL.svg";
import { ContactDetailsEmailIcon } from "../../../assets/icons";
import TagDisplay from "../../../app/common/components/TagDisplay";
import star from "../../../assets/icons/startag.svg";
import {
  getRoleLevel,
  NOT_SAY,
  startNewJobLookupStatus,
} from "../candidateProfilesFormConstants";
import yei from "../../../assets/icons/yei.svg";
import nei from "../../../assets/icons/nei.svg";
import { useSelector } from "react-redux";
import getFixedUrl from "../../employer/helpers/getFixedUrl";
import { getIndustryAndCategory } from "../../modes/helpers";

export default function CandidateProfile({
  candidateProfile,
  padding = 0,
  applicationCoverLetter = null,
}) {
  const { responsive } = useSelector((state) => state.app);

  function showInclusionDetail(detail) {
    return detail !== "" && detail !== NOT_SAY;
  }

  const pronouns = showInclusionDetail(candidateProfile.pronouns)
    ? `Pronouns: ${candidateProfile.pronouns}`
    : "";

  const gender = showInclusionDetail(candidateProfile.gender)
    ? `Gender identity: ${candidateProfile.gender}`
    : "";

  const ethnicity = showInclusionDetail(candidateProfile.ethnicity)
    ? `Ethnicity: ${candidateProfile.ethnicity}`
    : "";

  const diversity = [pronouns, gender, ethnicity].filter((i) => i !== "");

  return (
    <div style={{ padding: padding }}>
      <Grid.Row>
        <Grid.Column computer={8} tablet={11} mobile={15}>
          {(candidateProfile.isOpenToWork ||
            candidateProfile.isAvailableForInterviews) && (
            <div className={"body-blue-text tag-colour"}>
              {candidateProfile.isOpenToWork && (
                <span>Actively seeking jobs </span>
              )}
              {candidateProfile.isOpenToWork &&
                candidateProfile.isAvailableForInterviews && <span> | </span>}
              {candidateProfile.isAvailableForInterviews && (
                <span>Available for interview</span>
              )}
            </div>
          )}
          <h2 style={{ margin: "15px 0 10px" }}>
            {candidateProfile.name} {candidateProfile.currentJobTitle && " - "}{" "}
            {candidateProfile.currentJobTitle}
          </h2>
          {diversity.length === 1 && (
            <div className="smaller-text">{diversity[0]}</div>
          )}
          {diversity.length > 1 && (
            <div className="smaller-text">{diversity.join(" | ")}</div>
          )}
          {candidateProfile.bio && (
            <div
              style={{
                marginTop: 20,
                width: responsive.isMobile ? "94%" : "550px",
              }}
            >
              {candidateProfile.bio}
            </div>
          )}
          <div className="section-container">
            {candidateProfile.cv.url && (
              <a
                href={candidateProfile.cv.url}
                target={"_blank"}
                rel="noopener noreferrer"
                download
              >
                <img
                  className="clickable"
                  src={cv}
                  style={{ width: 80, height: 35 }}
                  alt="cv"
                />
              </a>
            )}
            {applicationCoverLetter && (
              <a
                href={applicationCoverLetter}
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                <img
                  className="clickable"
                  src={coverLetterIcon}
                  style={{ marginLeft: 10 }}
                  alt="cv"
                />
              </a>
            )}
            {candidateProfile.linkedInURL && (
              <a
                href={getFixedUrl(candidateProfile.linkedInURL)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{ height: 35, width: 35, marginLeft: 15 }}
                  src={linkedinIconL}
                  alt="icon"
                />
              </a>
            )}
            <div className="body-blue-text" style={{ margin: "14px 0" }}>
              <ContactDetailsEmailIcon />
              <span>{candidateProfile.email}</span>
            </div>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="body-blue-text">
        <Grid.Column computer={11} tablet={12} mobile={15}>
          {candidateProfile.keySkills.length > 0 && (
            <TagDisplay
              width={responsive.isMobile ? "95%" : "75%"}
              icon={star}
              title={"Key skills"}
              tags={candidateProfile.keySkills}
              margin={"0 0 18px 0"}
            />
          )}
          <div className="statement">
            <span className="semi-bold">My job search status: </span>
            <span>{startNewJobLookupStatus[candidateProfile.status]} </span>
          </div>
          <div className="statement">
            <span className="semi-bold">Level of roles I'm looking for: </span>
            <span>
              {candidateProfile.roleLevel
                .map((level) => getRoleLevel(level))
                .join(", ")}
            </span>
          </div>
          {candidateProfile.languages.length > 0 && (
            <div className="statement">
              <span className="semi-bold">Languages I speak: </span>
              <span>{candidateProfile.languages.join(", ")}</span>
            </div>
          )}
          {candidateProfile.industries.length > 0 && (
            <div className="statement">
              <span className="semi-bold">Industry: </span>
              <span>
                {candidateProfile.industries
                  .map((industry) => getIndustryAndCategory(industry))
                  .join(", ")}
              </span>
            </div>
          )}
          {candidateProfile.preferencesInterested.length > 0 && (
            <TagDisplay
              width={responsive.isMobile ? "95%" : "75%"}
              icon={yei}
              title={"Interested in:"}
              tags={candidateProfile.preferencesInterested}
              margin={"20px 0"}
              isShowBox={false}
            />
          )}
          {candidateProfile.preferencesNotInterested.length > 0 && (
            <TagDisplay
              width={responsive.isMobile ? "95%" : "75%"}
              icon={nei}
              title={"Not interested in:"}
              tags={candidateProfile.preferencesNotInterested}
              margin={"20px 0"}
              isShowBox={false}
            />
          )}
        </Grid.Column>
      </Grid.Row>
    </div>
  );
}
